import React from 'react';
import { BrandLogo } from './BrandLogo';
import { navLinks as allNavLinks } from '../data/election';
type SiteFooterProps = {
  hiddenHrefs?: string[];
};
export function SiteFooter({
  hiddenHrefs = []
}: SiteFooterProps) {
  const navLinks = allNavLinks.filter(l => !hiddenHrefs.includes(l.href));
  return <footer className="bg-[#0A1A4D] text-white" data-id="element-353" data-mp="3hj7vtdwt840c">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-8 px-6 py-12 md:flex-row" data-id="element-354" data-mp="3hglsjqgycanx">
        <span className="rounded-2xl bg-white px-5 py-3" data-id="element-355" data-mp="38hrojf1aki0c">
          <BrandLogo className="h-10 w-auto" data-id="element-356" data-mp="38g6v5sqpr542" />
        </span>
        <nav aria-label="Pie de página" data-id="element-357" data-mp="33i5dnc8xrdup">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-2" data-id="element-358" data-mp="33ix7oimvx3iv">
            {navLinks.map(l => <li key={l.href} data-id="element-359" data-mp="2ylooceq02tg1">
                <a href={l.href} className="text-sm text-white/70 transition hover:text-white" data-id="element-360" data-mp="11r1yc9o3pb3t">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>
      </div>
      <div className="border-t border-white/10" data-id="element-361" data-mp="15qlsq69wrunr">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-6 md:flex-row" data-id="element-362" data-mp="15sy8ccs71sxn">
          <p className="text-center text-xs text-white/50 md:text-left" data-id="element-363" data-mp="vsp7umr65lcg">
            © 2026 Grupo Consultor Colombiano · Elecciones Junta Directiva Cámara de Comercio de Cali, período 2027 – 2030.
          </p>
          <a href="https://makiathub.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-xs text-white/60 transition hover:text-white" data-id="element-364" data-mp="1ohmqws37fm69">
            Hecho por <span className="font-bold text-white underline-offset-4 hover:underline" data-id="element-365" data-mp="1er0f78ylzfsu">Makiat Hub</span>
          </a>
        </div>
      </div>
    </footer>;
}